import _ from 'lodash';
import * as React from 'react';
import { PayerIdBadge } from '../badge';
import * as S from './payer-search-result.styles';

export interface IPayerSearchResultProps {
    id?: string;
    name?: string;
    phone?: string;
    email?: string;
    inactive?: boolean;
    selected?: boolean;
}

export const PayerSearchResult: React.FC<IPayerSearchResultProps> = (props: IPayerSearchResultProps) => {
    const { id, name, phone, email, inactive, selected } = props;
    return (
        <S.Result selected={selected}>
            <S.Payer>
                <S.PayerTop>
                    {inactive && <b>INACTIVE</b>}
                    <b>Payer</b>
                    <S.Spacer />
                    <span>{phone}</span>
                    <b>{email}</b>
                </S.PayerTop>
                <S.PayerBottom>
                    <S.PayerName inactive={inactive}>{name}</S.PayerName>
                    <S.Spacer />
                    {id && (
                        <PayerIdBadge id={id} path={`/claims/by-payer/${id}`} tooltip="Find claims for this Payer" />
                    )}
                </S.PayerBottom>
            </S.Payer>
        </S.Result>
    );
};
